import styled from "styled-components";

export const InnerWrapper = styled.div({
  maxWidth: 900,
  width: "100%",
  margin: "auto",
  padding: "0 32px"
});
